import React from "react";
import './Benefits.css'
import icon1 from './icon1.png';
import icon2 from './icon2.png';
import icon3 from './icon3.png';
import icon4 from './icon4.png';
import icon5 from './icon5.png';
import ISO from './ISO.png';

import PAS from './PAS.png';
import monitor from './monitor.png';




const Benefits = () => {

  return (
    <div>
    <div className="carbon-benefits-container">
    <h2 className="carbon-title">
      Benefits Of <br/><span className="highlight">Carbon Neutral</span><br/>Events
    </h2>

    <div className="benefits-grid">
    <div className="benefit-card">
  <img src={icon1} alt="Environmental Impact" />
  <div className="benefit-card-content">
    <h3>Environmental Impact</h3>
    <p>Reduce your event’s carbon footprint, helping to build a sustainable future.</p>
  </div>
</div>


<div className="benefit-card">
  <img src={icon2} alt="Environmental Impact" />
  <div className="benefit-card-content">
    <h3>Brand Reputation</h3>
    <p>Showcase your commitment to environmental responsibility and enhance your image. </p>
  </div>
</div>

<div className="benefit-card">
  <img src={icon3} alt="Environmental Impact" />
  <div className="benefit-card-content">
    <h3>Cost Savings</h3>
    <p>Adopt Eco-friendly practices that can reduce operational costs. </p>
  </div>
</div>

<div className="benefit-card">
  <img src={icon5} alt="Environmental Impact" />
  <div className="benefit-card-content">
    <h3>Regulatory Compliance</h3>
    <p>Stay ahead of environmental regulations and future-proof your events.</p>
  </div>
</div>


<div className="benefit-card">
  <img src={icon4} alt="Environmental Impact" />
  <div className="benefit-card-content">
    <h3>Competitive Edge</h3>
    <p>Position yourself as a forward-thinking,
    responsible event organizer.</p>
  </div>
</div>

    </div>



  </div>

  <div className="global-certification-section">
  
  <div className='certification-container'>
  <div className="certification-left">
    <div  className="certification-left-logos">
    <img src={ISO} alt="ISO 14064" className="cert-logo" />
    <img src={PAS} alt="Carbon Neutral PAS 2060" className="cert-logo" />
    </div>
    <div className="cert-text">
      <h3>Market your event’s sustainability with credibility, </h3>
      <p>
       powered by<strong> Globally Recognized Standards.</strong>
      </p>
    </div>
  </div>
  <div className="certification-right">
    <img src={monitor} alt="Dashboard" className="dashboard-img" />
  </div>
  </div>

 

</div>



  </div>
  )
}

export default Benefits
